import ApiService from '../api.service';
import { LocaleService } from '../storage.service';

export default {
    async getKSKtoHouseBindings(itemsPerPage = 10, page = 0, orderBy = null, where = null) {
        const locale = '___' + LocaleService.getLocale();

        const { data: response } = await ApiService.post('ksk/KSKHousesPeriods', {
            itemsPerPage,
            currentItem: itemsPerPage * (page - 1),
            locale,
            orderBy,
            where
        });
        return response.data;
    },

    async addKSKtoHouseBinding(payload) {
        const { data: response } = await ApiService.post('ksk/create_ksk_house_period', payload);
        return response.data;
    },

    async updateKSKtoHouseBinding(id, payload) {
        const { data: response } = await ApiService.post(`ksk/update_ksk_house_period/${id}`, payload);
        return response.data;
    },

    async deleteKSKtoHouseBinding(isas_period_rid) {
        const { data: response } = await ApiService.post(`ksk/delete_ksk_house_period`, { isas_period_rid });
        return response.data;
    }
};
